import { FiTruck, FiShield, FiRefreshCcw, FiHeadphones } from "react-icons/fi";

const items = [
  { icon: FiTruck, title: "ارسال سریع", text: "پردازش سفارش‌ها با مسیر ساده و قابل پیگیری" },
  { icon: FiShield, title: "انتخاب مطمئن", text: "محصولات کاربردی با اطلاعات واضح برای خرید بهتر" },
  { icon: FiRefreshCcw, title: "پیگیری سفارش", text: "مشاهده وضعیت سفارش از حساب کاربری" },
  { icon: FiHeadphones, title: "پشتیبانی خرید", text: "راهنمایی برای انتخاب مدل، سایز و ثبت سفارش" }
];

const TrustSection = () => {
  return (
    <section className="trust-section">
      {items.map((item) => {
        const Icon = item.icon;

        return (
          <div className="trust-card" key={item.title}>
            <span>
              <Icon size={22} />
            </span>

            <div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default TrustSection;
